import { Translation } from '@ps/web-shared-components';
import React from 'react';

import Prompt from '../../Prompt/Prompt';

import {
  TXTWCL_Bank_transfers_unavailable,
  TXTWCL_Deposit_another_way,
  TXTWCL_SorryX_we_canXt_accept_deposit_ELL_1
} from './NoBankTransfersAvailable.messages.json';

interface Props {
  onClose(): void;
}

const NoBankTransfersAvailable: React.FC<Props> = ({ onClose }) => (
  <Prompt
    onClose={onClose}
    variant="warning"
    title={{
      translation: TXTWCL_Bank_transfers_unavailable
    }}
    primaryButton={{
      translation: TXTWCL_Deposit_another_way
    }}
    alert={<Translation {...TXTWCL_SorryX_we_canXt_accept_deposit_ELL_1} />}
  />
);

export default NoBankTransfersAvailable;
